import { Vue, Prop } from 'vue-property-decorator'
import { ISheetGridField } from '@/interfaces/components'
import Component from 'vue-class-component'
import { VCol, VIcon, VRow, VSheet, VSpacer, VLayout, VBtn } from 'vuetify/lib'
import './SheetGrid.scss'

export enum ModuleType {
	IMOBILIARIO = 2
}
@Component({})
export class SheetGridHighlight extends Vue {
	@Prop({ type: Array, required: true }) fieldsHighlight!: Array<ISheetGridField>
	@Prop({ type: Number }) productType!: ModuleType

	render() {
		return (
			<VLayout class="sheetgrid-container">
				<VSheet width="100%" class="pa-5" color="#F3F3F3">
					<VRow>{this.fieldsHighlight.map(this.renderFieldHighlight)}</VRow>
				</VSheet>
			</VLayout>
		)
	}
	renderFieldHighlight(field: ISheetGridField) {
		return (
			<VCol cols={field.cols ? field.cols : '2'}>
				<div class="white pa-4" style="height: 100px">
					<VLayout align="start" justify="center">
						<div class="sheetgrid-title--highlight">{field.field}</div>
						<VSpacer />
						<VBtn onClick={field.iconOnClick} icon color="white" text class="pa-0" aria-label={field.ariaLabel}>
							<VIcon color="primary" size="14">
								{field.icon}
							</VIcon>
						</VBtn>
					</VLayout>

					<div class="py-2">{this.productType === ModuleType.IMOBILIARIO && <div class="title-sheetgrid">{field.value ?? ' '}</div>}</div>
				</div>
			</VCol>
		)
	}
}

export default SheetGridHighlight
